/**
 * Shared composable for persisting items-per-page preference across views.
 * Usage: const { itemsPerPage, updatePageSize } = usePersistedPageSize();
 */
const STORAGE_KEY = 'mivu_items_per_page';
const DEFAULT_SIZE = 10;

export function getPersistedPageSize() {
    const saved = localStorage.getItem(STORAGE_KEY);
    return saved ? Number(saved) : DEFAULT_SIZE;
}

export function setPersistedPageSize(size) {
    localStorage.setItem(STORAGE_KEY, size);
}
